<div class="title-grid">
    <img class="title-icon" [src]="'/assets/images/grid/questionnaires.svg'" />
    <!-- [src]="this.title$()?.id == 0 ? '/assets/images/grid/questionnaires.svg' : '/assets/images/file.svg'" /> -->
    <h2 translate [translateParams]="{ category: {name:'כל השאלונים',enName: 'All Questionnaires'}}">
        grid.categoryName</h2>
</div>
<div class="page-layout">

  <div class="grid" [ngClass]="{'warp-no-result':!isResult$()}">
    <que-manipulations-toolbar
      [isEmpty]="isEmpty$()"
      [isTowViews]="true"
      [isQuestionnariePage]="true">
    </que-manipulations-toolbar>

    <ng-container *ngIf="isResult$() ; else thereIsNotResult">
      <div *ngIf="listView$()">
        <div class="scroll" [ngClass]="{'expanded':!isFilterListOpen$()}" (scroll)="checkPositions()">
          <que-grid-header class="position-sticky"></que-grid-header>

          <que-questionnaires-list-item
            *ngFor="let q of questionnaires$()?.result; let i = index"
            [questionnaire]="q"
            #itemElement>
          </que-questionnaires-list-item>

          <ng-container *ngFor="let _ of [].constructor(3)">
            <div class="item-in-loading" *ngIf="loadingExtra$()"></div>
          </ng-container>
        </div>
      </div>

      <div *ngIf="!listView$()">
        <div class="scroll" [ngClass]="{'expanded':!isFilterListOpen$()}">
          <que-templates-page></que-templates-page>
        </div>
      </div>
    </ng-container>
  </div>
  <div class="status-flow-side" *ngIf="currentQuestionnaire$() != null">
    <que-questionnaire-status-flow
      [guid]="currentQuestionnaire$()?.guidToUser"
      [questionnaire]="currentQuestionnaire$()">
    </que-questionnaire-status-flow>
  </div>
</div>

<ng-template #thereIsNotResult>
    <div class="grid no-result" *ngIf="!loading$() else loading">
        <que-no-result [isEmpty]="isEmpty$()" [type]="'questionnaire'"></que-no-result>
    </div>
</ng-template>
<ng-template #loading>
    <div class="no-result" [ngClass]="{'wrap-no-result-templates': !listView$()}">
        <ng-container *ngFor="let _ of [].constructor(10)">
            <div class="load-enimation" [ngClass]="{'item-in-loading': listView$(), 'template-loading': !listView$()}">
            </div>
        </ng-container>
    </div>
</ng-template>